<div class="security-container" fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="column center">
        <app-single-card>
            <div fxLayout="row" fxLayoutAlign="center center">
                <img class="logo" [src]="Logo" alt="Laboratory Logo" />
            </div>
            <form [formGroup]="patientSignUpForm" (submit)="submit()">
                <div fxLayout="column" fxLayoutAlign="space-between" fxLayoutAlign.xs="center center" style="padding: 16px;">
                    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between">
                        <div fxLayout="column" class="dx-field">
                            <div class="dx-field-label">Last Name <span class="ocl-required-indicator">*</span></div>
                            <div class="dx-field-value">
                                <dx-text-box formControlName="lastName" class="uppercase">
                                    <dx-validator validationGroup="patientSignUpForm">
                                        <dxi-validation-rule type="required" message="Last name is required"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-text-box>
                            </div>
                        </div>
                        <div fxLayout="column" class="dx-field">
                            <div class="dx-field-label">First Name <span class="ocl-required-indicator">*</span></div>
                            <div class="dx-field-value">
                                <dx-text-box formControlName="firstName" class="uppercase">
                                    <dx-validator validationGroup="patientSignUpForm">
                                        <dxi-validation-rule type="required" message="First name is required"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-text-box>
                            </div>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between">
                        <div fxLayout="column" class="dx-field">
                            <div class="dx-field-label">Birth Date <span class="ocl-required-indicator">*</span></div>
                            <div class="dx-field-value">
                                <dx-date-box formControlName="birthDate">
                                    <dx-validator validationGroup="patientSignUpForm">
                                        <dxi-validation-rule type="required" message="Birth Date is required"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-date-box>
                            </div>
                        </div>
                        <div fxLayout="column" class="dx-field">
                            <div class="dx-field-label">Lab Patient ID <span class="ocl-required-indicator">*</span></div>
                            <div class="dx-field-value">
                                <dx-text-box formControlName="patientId">
                                    <dx-validator validationGroup="patientSignUpForm">
                                        <dxi-validation-rule type="required" message="Lab Patient ID is required"></dxi-validation-rule>
                                    </dx-validator>
                                </dx-text-box>
                            </div>
                        </div>
                    </div>
                    <div fxLayout="column" class="dx-field">
                        <div class="dx-field-label">Email <span class="ocl-required-indicator">*</span></div>
                        <div class="dx-field-value" style="width: 100% !important;" [ngStyle.xs]="{width: '180px'}">
                            <dx-text-box formControlName="email">
                                <dx-validator validationGroup="patientSignUpForm">
                                    <dxi-validation-rule type="required" message="Email is required"></dxi-validation-rule>
                                    <dxi-validation-rule type="email" message="Email is invalid"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-box>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px !important;">
                        <dx-button text="Sign Up" [useSubmitBehavior]="true" style="height: 26px !important; width: 100px !important;"></dx-button>
                    </div>
                    <div class="link-container">
                        <a routerLink="/login">Go Back</a><br/>
                    </div>
                </div>
            </form>
        </app-single-card>
    </div>
</div>
<dx-load-panel
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="isLoading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false">
</dx-load-panel>
